import { render, staticRenderFns } from "./ToolsCard.vue?vue&type=template&id=1228991e"
import script from "./ToolsCard.vue?vue&type=script&lang=js"
export * from "./ToolsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports